module.exports = __webpack_public_path__ + "img/glogo207.c2cf6130.png";